/**
 * PNR Service
 * The PNR integration API
 *
 * The version of the OpenAPI document: master-7a801ca4-799560
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@nestjs/common';
import { HttpService } from '@nestjs/axios';
import { AxiosResponse } from 'axios';
import { Observable } from 'rxjs';
import { ManualImportRequestDto } from '../model/manualImportRequestDto';
import { ManualImportResponseDto } from '../model/manualImportResponseDto';
import { Configuration } from '../configuration';
import { COLLECTION_FORMATS } from '../variables';


@Injectable()
export class ManualImportApi {

    protected basePath = 'http://.';
    public configuration = new Configuration();

    constructor(protected httpClient: HttpService, @Optional() configuration: Configuration) {
        this.configuration = configuration || this.configuration;
        this.basePath = configuration?.basePath || this.basePath;
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        return consumes.includes(form);
    }

    /**
     * 
     * 
     * @param manualImportRequestDto 
     */
    public runManualImport(manualImportRequestDto: ManualImportRequestDto, ): Observable<AxiosResponse<ManualImportResponseDto>>;
    public runManualImport(manualImportRequestDto: ManualImportRequestDto, ): Observable<any> {

        if (manualImportRequestDto === null || manualImportRequestDto === undefined) {
            throw new Error('Required parameter manualImportRequestDto was null or undefined when calling runManualImport.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.post<ManualImportResponseDto>(`${this.basePath}/manual-import/run`,
            manualImportRequestDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
}
